import React from 'react'

import { renderEmail } from 'react-html-email';
import { Provider } from 'react-redux'

import Email from "./email";

export const renderEmailString = (store, html = true) => {
    let emailString = renderEmail(
        <Provider store={store}>
            <Email html={html}/>
        </Provider>
    );
    const ifRegex = /<span><!--\[#if/g;
    const ifRegex2 = /<!--\[#if/g;
    const elseRegex = /<span><!--\[#else/g;
    const endCommentRegex = /]--><\/span>/g;
    const endCommentRegex2 = /]-->/g;
    const endIfRegex = /<span><!--\[\/#if/g;
    const endIfRegex2 = /<!--\[\/#if/g;
    emailString = emailString.replace(ifRegex, '[#if');
    emailString = emailString.replace(ifRegex2, '[#if');
    emailString = emailString.replace(elseRegex, '[#else');
    emailString = emailString.replace(endCommentRegex, ']');
    emailString = emailString.replace(endCommentRegex2, ']');
    emailString = emailString.replace(endIfRegex, '[/#if');
    emailString = emailString.replace(endIfRegex2, '[/#if');
    return emailString;
};
